export class ForceReloadMessage {
  static readonly NAME = 'ftr-core/ForceReloadMessage'
  $name = ForceReloadMessage.NAME
  $version = 0
}
